/**
 * Estado inicial del reducer PopUpTokenExpired.
 * @typedef {Object} Estado
 * @property {boolean} expired -  Se utiliza como booleano para mostrar el popup de token expirado.
 * @property {any} timeout - Almacena el timeout para poder limpiarlo después.
 */

const EstadoIncial = {
  expired: false,
  timeout: null,
};

/**
 * Reducer para manejar el estado de expiración de token en un modal.
 *
 * @param {Estado} state - El estado actual del reducer.
 * @param {Object} action - La acción que se va a procesar.
 * @param {string} action.type - Tipo de acción que determina cómo se actualiza el estado.
 * @param {*} action.payload - Datos asociados a la acción que se utilizarán para actualizar el estado.
 * @returns {Estado} El nuevo estado actualizado basado en la acción recibida.
 */

const PopUpTokenExpired = (state = EstadoIncial, action) => {
  switch (action.type) {
    case "SET_TOKEN_EXPIRED":
      console.log("El estado del popup de token expirado ha cambiado a:", action.payload);
      return { ...state, expired: action.payload };
    case "SET_TIMEOUT":
      console.log("El timeout ha cambiado a:", action.payload);
      return { ...state, timeout: action.payload };

    default:
      return state;
  }
};
export default PopUpTokenExpired;
